module.exports = __webpack_public_path__ + "img/engagement-photo-6.ea98fbdf.jpg";